
/**
 * 뉴스 기본 정보
 */
export type NewsResponseBasicInfoAllOfTwo = {
  publishedAt: string;
  title: string;
};
